<template>
  <div>
    <vs-table :max-items="5" pagination :data="tickets || []" search>
      <template slot="header">
        <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
          {{ $t("customers.label.tickets") }}
        </div>
        <span class="vx-col order-1">
          <vs-button
            icon-pack="feather"
            icon="icon-plus"
            @click="
              $router.push({
                name: 'Create Ticket',
                params: { id: $route.params.id },
              })
            "
            size="small"
            >{{ $t("customers.label.create_ticket") }}</vs-button
          >
        </span>
      </template>
      <template slot="thead">
        <vs-th>{{ $t("customers.label.id") }}</vs-th>
        <vs-th>{{ $t("customers.label.priority") }}</vs-th>
        <vs-th>{{ $t("customers.label.created_date") }}</vs-th>
        <vs-th>{{ $t("customers.label.created_time") }}</vs-th>
        <vs-th>{{ $t("customers.label.problem_code") }}</vs-th>
        <!-- <vs-th>{{ $t("customers.label.assign_to") }}</vs-th> -->
        <vs-th>{{ $t("customers.label.last_comment") }}</vs-th>
        <vs-th>{{ $t("customers.label.status") }}</vs-th>
        <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="index" :data="ticket" v-for="(ticket, index) in data">
          <vs-td :data="ticket.id">{{ ticket.id }}</vs-td>

          <vs-td :data="ticket.priority">
            <span :style="{ color: priorityColor(ticket.priority) }">
              {{ ticket.priority }}
            </span>
          </vs-td>
          <vs-td :data="ticket.strTicketDate">{{
            getDate2(ticket.strTicketDate)
          }}</vs-td>
          <vs-td :data="ticket.strTicketDate">{{
            (ticket.strTicketDate && getTime(ticket.strTicketDate)) || "-"
          }}</vs-td>

          <vs-td :data="ticket.problemCode">{{
            ticket.problemDescription
          }}</vs-td>
          <!-- <vs-td :data="ticket.userName">{{ ticket.userName }}</vs-td> -->
          <vs-td v-if="ticket.lastComment" :data="ticket.lastComment">{{
            ticket.lastComment
          }}</vs-td>
          <vs-td v-else :data="ticket.problemDescription">{{
            ticket.problemDescription
          }}</vs-td>

          <vs-td :data="ticket.status">
            <span :style="{ color: statusColor(ticket.status) }">
              {{ ticket.status }}
            </span>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <div class="container_img">
              <feather-icon
                v-if="
                  ['CLOSED'].includes(
                    ticket.status
                  )
                "
                title="View Ticket"
                @click="viewTicketData(ticket)"
                icon="EyeIcon"
                class="icon_row"
                svgClasses="w-5 h-5 text-primary stroke-current"
              />
              <feather-icon
                v-if="ticket.status !== 'CLOSED'"
                title="Edit Ticket"
                @click.stop="editTicket(ticket)"
                icon="EditIcon"
                class="icon_row"
                svgClasses="w-5 h-5 hover:text-primary stroke-current orange_icon"
              />
              <feather-icon
                v-if="
                  ticket &&
                  ticket.attachments &&
                  ticket.attachments[0] &&
                  ticket.attachments[0].fileName &&
                  ticket.attachments[0].fileName !== 'null'
                "
                title="Download Uploaded File"
                icon="DownloadIcon"
                @click.stop="downloadFile(ticket.id)"
                class="icon_row mr-1 text-warning"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
              />
              <feather-icon
                v-if="ticket.status !== 'CLOSED'"
                title="Close Ticket"
                @click.stop="removeTicket(ticket.id)"
                icon="XIcon"
                class="icon_row"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
              />
              <!-- <feather-icon
                v-if="ticket.status === 'CLOSED'"
                title="Reopen Ticket"
                @click.stop="reopenTicket(ticket.id)"
                icon="RefreshCwIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
              /> -->
              <feather-icon
                title="Add Ticket Task"
                @click.stop="addTicketTask(ticket)"
                icon="PlusIcon"
                class="icon_row"
                svgClasses="w-5 h-5 hover:text-primary stroke-current orange_icon"
              />
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.close_ticket')"
        :active.sync="cancelTicketPopup"
        class="popup-close mid-popup"
      >
        <form ref="form">
          <div class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.status")
                }}<span class="required"> *</span></small
              >
              <v-select
                :options="cancelStatus"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="cancelObj.status"
                class="min-w-200 w-full mb-2"
              />
            </div>
          </div>
          <div class="vx-col sm:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.Resolution")
                }}<span class="required"> *</span></small
              >
              <vs-textarea
                class="w-full textbox"
                v-model="cancelObj.resolutionDescription"
                hint="Please provide as much detail as possible so we can best assist you."
              />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="cancelTicket"
                class="footerButton-next mt-4 mb-4"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.ViewTickets')"
        :active.sync="viewTicketPopup"
        class="popup-close"
      >
        <div class="w-full">
          <table class="table w-full table-bordered table-striped">
            <tr>
              <td class="center">
                <b>{{ $t("customers.label.TicketHistory") }}</b>
              </td>
            </tr>

            <tr v-for="(item, index) in ticketViewById" :key="index">
              <td class="w-full detail-text">
                <div class="p-2">
                  <div class="vx-row w-full detail-text">
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.id") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.id }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.priority") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.priority }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.status") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.status }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.ticket_date") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">
                      {{ dateFormat(item.ticketDate) }}
                    </div>

                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.team") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.teamCode }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.team_user") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.assignedTo }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.last_comment") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">{{ item.lastComment }}</div>
                    <div class="vx-col md:w-1/4">
                      <b>{{ $t("customers.label.problem_description") }}</b>
                    </div>
                    <div class="vx-col md:w-1/4">
                      {{ item.problemDescription }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.ReopenTicket')"
        :active.sync="reopenTicketPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="vx-col sm:w-full lg:w-full md:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.comment")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.comment')"
                >
                  <vs-textarea class="w-full" v-model="reopenComment" />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="center">
              <span class="ml-1 mr-1">
                <vs-button
                  @click="reopenCustomerTicket"
                  class="footerButton-next mt-4 mb-4"
                  style="top: 0px"
                  >{{ $t("customers.label.reopen") }}</vs-button
                >
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import vSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import { mapState } from "vuex";
import { BUCKET_BASE_URL } from "@/http/index";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};

export default {
  props: ["clientId", "refresh"],
  emits: ["openTicket"],
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      ticketId: "",
      ticketCreatePopup: false,
      cancelTicketPopup: false,
      cancelStatus: ["OPEN", "IN_PROGRESS", "RESOLVED", "CLOSED", "REOPEN"],
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      teamUsersItem: [{ id: null, username: "all" }],
      cancelObj: {
        status: "",
        resolutionDescription: "",
        // ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      },
      viewTicketPopup: false,
      reopenTicketPopup: false,
      reopenComment: "",
    };
  },
  components: {
    Datepicker,
    flatPickr,
    quillEditor,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    tickets() {
      return this.$store.getters["customerTicket/getClientTickets"];
    },
    template() {
      return this.$store.getters["customer/getTicketTemplate"];
    },
    ...mapState({
      teamUsers: (state) => state.customer.teamUsers,
      ticketById: (state) => state.customerTicket.ticketById,
      ticketViewById: (state) => state.customerTicket.ticketViewById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getTime(time) {
      return time.split(" ")[1];
    },
    viewTicketData(ticket){
      this.$router.push({
        name: "Customer View Ticket",
        params: { id: this.$route.params.id, ticketId: ticket.id },
      });
    },
    editTicket(ticket) {
      this.$router.push({
        name: "Edit Ticket",
        params: { id: this.$route.params.id, ticketId: ticket.id },
      });
    },
    addTicketTask(ticket) {
      this.$router.push({
        name: "Ticket Task",
        params: { id: this.$route.params.id, ticketId: ticket.id },
      });
    },
    priorityColor(priority) {
      let color = "";
      switch (priority.toUpperCase()) {
        case "HIGH":
          color = "red";
          break;
        case "MEDIUM":
          color = "#FFC107";
          break;
        case "LOW":
          color = "blue";
          break;
        default:
          color = "grey";
      }
      return color;
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "OPEN":
          color = "blue";
          break;
        case "CLOSED":
          color = "red";
          break;
        case "IN_PROGRESS":
          color = "green";
          break;
        case "RESOLVED":
          color = "green";
          break;
        case "REOPEN":
          color = "orange";
          break;
        default:
          color = "black";
      }
      return color;
    },
    async viewTicket(item) {
      this.viewTicketPopup = true;
      await this.$store.dispatch("customerTicket/setsTicketById", item.id);
    },
    getDate(dateArray) {
      const date = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
      const formattedDate = moment(date).format(this.formattedDate);
      return formattedDate;
    },
    getDate2(date) {
      const d = moment(date, "DD-MM-YYYY");
      const formattedDate = d.format(this.formattedDate);
      return formattedDate;
    },
    async getTickets() {
      try {
        await this.$store.dispatch(
          "customerTicket/setClientTickets",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getSubCategory(categoryId) {
      try {
        await this.$store.dispatch("tickets/getTicketSubCategory", categoryId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUserByTeam() {
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    downloadFile(ticketId) {
      window.open(BUCKET_BASE_URL + `/tickets/${ticketId}/print`);
    },
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    async cancelTicket() {
      try {
        // this.cancelObj.ticketURL = `${this.ticket.ticketURL2}${this.clientId}`;
        await this.$store.dispatch("customer/cancelTicketAction", {
          id: this.ticketId,
          data: this.cancelObj,
        });
        this.cancelTicketPopup = false;
        this.getTickets();
        if (this.cancelObj.status == "CLOSED" || this.cancelObj.status == "RESOLVED") {
          await this.$swal({
            title: "Success",
            icon: "success",
            text: `Ticket ${this.capitalize(this.cancelObj.status)} Successfully!`,
            type: "success",
          });
        } else{
          await this.$swal({
            title: "Success",
            icon: "success",
            text: `Ticket Status Changed To ${this.capitalize(this.cancelObj.status)}`,
            type: "success",
          });
        }
      } catch (error) {
        this.cancelTicketPopup = false;
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong!",
          type: "error",
        });
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async removeTicket(id) {
      this.cancelTicketPopup = true;
      this.ticketId = id;
      this.cancelObj.resolutionDescription = "";
      this.cancelObj.status = "";
      try {
        // this.cancelStatus = await this.$store.dispatch(
        //   "entity/getCancelTicketTemplate"
        // );
        // this.getTickets();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async reopenTicket(id) {
      this.reopenTicketPopup = true;
      this.ticketId = id;
    },
    async reopenCustomerTicket() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch(
          "customerTicket/reopenCustomerTicketAction",
          {
            id: this.ticketId,
            data: { comments: this.reopenComment },
          }
        );
        this.getTickets();
        this.reopenTicketPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Reopened Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    dateFormat(date) {
      return moment(date).format("DD MMMM YYYY");
    },
  },
  async mounted() {
    await this.getTickets();
  },
  watch: {
    ticketCreatePopup(newValue) {
      if (newValue) {
        this.ticket.ticketDate = moment().format("dd MMMM yyyy HH:mm:ss a");
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
    "ticket.teamCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTeamUsers(this.ticket.teamCode);
      }
    },
    "ticket.dueTime"() {
      debugger;
    },
    refresh() {
      this.getTickets();
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-text {
  font-size: 0.8rem;

  .vx-row > .vx-col {
    padding: 0 0.2rem;
  }
}

.action-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.priority-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}

.priority-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}

.priority-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff0000;
  color: #ff0000 !important;
}

.priority-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
</style>
